<template>
	<TheTable
		class="table__logs"
		:tableData="logs"
		:loading="loading"
		:defaultSort="{ prop: 'timestamp', order: 'descending' }"
		:show-header="false"
	>
		<el-table-column prop="timestamp" label="" width="160">
			<template #default="scope">
				<span>{{ $formatDate(scope.row.timestamp, 'DD.MM.YYYY HH:mm') }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="actorName" label="" width="250">
			<template #default="scope">
				<span>{{ scope.row.actorName }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="" width="200">
			<template #default="scope">
				<span>{{ scope.row.actorRoles.join(', ') }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="message" label="" :class-name="'cell--alignleft'">
			<template #default="scope">
				<span>{{ scope.row.message }}</span>
			</template>
		</el-table-column>
	</TheTable>
</template>

<script lang="ts">
import TheTable from '../TheTable.vue';
import { HistoryEntryResponse } from '@/types/types';

/**
 * Zeigt den lesbaren Verlauf eines Falls, einer Beschwerde oder eines Benutzers.
 * Der Text kommt fertig vom Backend (`message`), hier wird nichts mehr interpretiert.
 */
export default {
	name: 'LogsTable',
	props: {
		logs: {
			type: Array as () => HistoryEntryResponse[],
			default: () => [],
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		TheTable,
	},
};
</script>

<style lang="scss">
.table__logs.el-table {
	.el-table__body {
		background-color: transparent !important;

		.el-table__row {
			height: 60px;
			.el-table__cell,
			.el-table__cell:first-child,
			.el-table__cell:last-child {
				border: 0px;
				vertical-align: top;
			}
		}
	}
}
</style>
